var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth main"},[_c('img',{staticClass:"auth__logo",attrs:{"alt":"Vue logo","src":require(("@/assets/img/" + _vm.logo))}}),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }